import { html } from 'lit';
import { sectionHeading } from '../components/sectionHeading.js';
import type { LandingContent } from '../../shared/content/landingContent.js';
import { editorSemanticText } from '../editor/editorSemanticText.js';
import {
  editorNodeClass,
  editorNodeClick,
  editorNodePointerDown,
  editorNodeStyle,
  type LandingEditorRenderOptions,
} from '../editor/landingEditorRender.js';

export const qualitySection = (content: LandingContent, editor?: LandingEditorRenderOptions) => html`
  <section
    id="qualitaet"
    class=${editorNodeClass(editor, 'section.quality', 'vp-section vp-quality-section')}
    style=${editorNodeStyle(editor, 'section.quality')}
    @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, 'section.quality', event)}
    @click=${(event: MouseEvent) => editorNodeClick(editor, 'section.quality', event)}
  >
    <div class="vp-shell">
      ${sectionHeading({
        eyebrow: content.quality.eyebrow,
        title: content.quality.title,
        highlight: content.quality.titleHighlight,
        text: content.quality.text,
        align: 'center',
        editor,
        elementPrefix: 'quality',
      })}

      <div
        class=${editorNodeClass(editor, 'quality.stats', 'vp-quality-stats')}
        style=${editorNodeStyle(editor, 'quality.stats')}
        @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, 'quality.stats', event)}
        @click=${(event: MouseEvent) => editorNodeClick(editor, 'quality.stats', event)}
      >
        ${content.quality.stats.map(
          (stat, index) => html`
            <div
              class=${editorNodeClass(editor, `quality.stat.${index}`, 'vp-quality-stat reveal-card')}
              style=${editorNodeStyle(editor, `quality.stat.${index}`)}
              @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, `quality.stat.${index}`, event)}
              @click=${(event: MouseEvent) => editorNodeClick(editor, `quality.stat.${index}`, event)}
            >
              <span
                class=${editorNodeClass(editor, `quality.stat.${index}.value`, 'vp-quality-stat-value')}
                style=${editorNodeStyle(editor, `quality.stat.${index}.value`)}
                @pointerdown=${(event: PointerEvent) =>
                  editorNodePointerDown(editor, `quality.stat.${index}.value`, event)}
                @click=${(event: MouseEvent) => editorNodeClick(editor, `quality.stat.${index}.value`, event)}
                >${stat.value}</span
              >
              <span
                class=${editorNodeClass(editor, `quality.stat.${index}.label`, 'vp-quality-stat-label')}
                style=${editorNodeStyle(editor, `quality.stat.${index}.label`)}
                @pointerdown=${(event: PointerEvent) =>
                  editorNodePointerDown(editor, `quality.stat.${index}.label`, event)}
                @click=${(event: MouseEvent) => editorNodeClick(editor, `quality.stat.${index}.label`, event)}
                >${stat.label}</span
              >
            </div>
          `,
        )}
      </div>

      <div
        class=${editorNodeClass(editor, 'quality.points', 'vp-card-grid vp-card-grid-four vp-quality-points')}
        style=${editorNodeStyle(editor, 'quality.points')}
        @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, 'quality.points', event)}
        @click=${(event: MouseEvent) => editorNodeClick(editor, 'quality.points', event)}
      >
        ${content.quality.points.map(
          (point, index) => html`
            <article
              class=${editorNodeClass(editor, `quality.point.${index}`, 'vp-info-card reveal-card')}
              style=${editorNodeStyle(editor, `quality.point.${index}`)}
              @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, `quality.point.${index}`, event)}
              @click=${(event: MouseEvent) => editorNodeClick(editor, `quality.point.${index}`, event)}
            >
              <span
                class=${editorNodeClass(editor, `quality.point.${index}.icon`, point.iconClass)}
                style=${editorNodeStyle(editor, `quality.point.${index}.icon`)}
                @pointerdown=${(event: PointerEvent) =>
                  editorNodePointerDown(editor, `quality.point.${index}.icon`, event)}
                @click=${(event: MouseEvent) => editorNodeClick(editor, `quality.point.${index}.icon`, event)}
              ></span>
              ${editorSemanticText({
                editor,
                elementId: `quality.point.${index}.title`,
                fallbackTag: 'h3',
                content: point.title,
              })}
              ${editorSemanticText({
                editor,
                elementId: `quality.point.${index}.text`,
                fallbackTag: 'p',
                content: point.text,
              })}
            </article>
          `,
        )}
      </div>
    </div>
  </section>
`;
